import api from 'api';
import {
  NOTIFICATION_TYPE,
  NOTIFICATION_TYPE_CODE,
  NotificationType,
} from 'models/Notification';
import { getSigningPathWithReturnPath } from 'agreementUtils';
import { getIsNativeNdaNotification } from './utils';

export const getNotificationRedirectionDynamicPath = (
  notification: NotificationType,
): (() => Promise<string>) | null => {
  const { typeCode, content } = notification;

  // Old notification has direct link to envelopeTemplateUrl
  if (content.envelopeTemplateUrl) {
    return undefined;
  }

  try {
    switch (typeCode) {
      case NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SENT_NDA]:
      case NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SIGNED_NDA]: {
        const { envelopeId, leadId } = content || {};

        if (!leadId) {
          throw new Error('Missing params for viewNda');
        }

        if (getIsNativeNdaNotification(content))
          return getNativeNdaRedirection(notification);

        return async () => {
          const { data } = await api.portfolio.seller.viewNda(
            leadId,
            envelopeId,
          );
          return data.url;
        };
      }
      default:
        return null;
    }
  } catch (error) {
    return;
  }
};

const getNativeNdaRedirection = ({ typeCode, content }: NotificationType) => {
  const { leadId } = content;

  if (typeCode === NOTIFICATION_TYPE_CODE[NOTIFICATION_TYPE.SENT_NDA])
    return async () => {
      const {
        data: { url },
      } = await api.agreements.getLeadSigningLink(leadId);

      return getSigningPathWithReturnPath(
        url,
        `${window.location.pathname}${window.location.search}`,
      );
    };

  return async () => {
    const { data } = await api.portfolio.seller.previewNdaProofFile(leadId);

    return data.url;
  };
};
